import { Command } from "ckeditor5";
// @ts-ignore
import AiExpandResponseWithContextModel from "./aiExpandResponseWithContextModel";
// @ts-ignore
import Messenger from "messaging/messenger";
// @ts-ignore
import i18next from "i18n/i18n";
import {
  getSelectedOrAllText,
  replaceText,
  removeFormattingConfirmation,
} from "./responseTransformationPluginUtil";

export default class ExpandResponseWithContextCommand extends Command {
  async execute(): Promise<void> {
    const confirmed = await removeFormattingConfirmation();
    if (!confirmed) return;

    const editor = this.editor;
    const kbId = editor.config.get("ak.kbId");
    const intentId = editor.config.get("ak.intentId");
    const responseId = editor.config.get("responseId");
    const localeId = editor.config.get("languageId");
    const { text, isSelection } = getSelectedOrAllText(editor);
    if (!text || !text.trim()) {
      return;
    }

    this.isEnabled = false;
    Messenger.vent.trigger("show:saving:display");

    try {
      const model = new AiExpandResponseWithContextModel.responseExpand({
        kbId: kbId,
        intentId: intentId,
        isHtml: !isSelection,
        responseId: responseId,
        text: text,
        targetLocaleId: localeId,
      });

      await model.saveModelPromise();
      const expandedText = model.get("text");
      if (expandedText) {
        replaceText(editor, expandedText, isSelection);
      }
    } catch (xhr) {
      console.error("Expand text with context failed", xhr);
      Messenger.okDialog(i18next.t("ai.error.expandTextWithContextError"));
    } finally {
      Messenger.vent.trigger("close:saving:display");
      this.isEnabled = true;
    }
  }
}

export const EXPAND_WITH_CONTEXT = "expandWithContext";
